export const CHANGE_ACTIVE_TAB_INDEX = 'CHANGE_ACTIVE_TAB_INDEX';

export const SET_STATISTIC_SUMMARY_FILTER = 'SET_STATISTIC_SUMMARY_FILTER';
export const RESET_STATISTIC_SUMMARY_FILTER = 'RESET_STATISTIC_SUMMARY_FILTER';

export const SET_SUMMARY_DATA = 'SET_SUMMARY_DATA';

export const SET_TABLE_LIST = 'SET_TABLE_LIST';
export const SET_TABLE_PAGE_INFO = 'SET_TABLE_PAGE_INFO';
export const RESET_TABLE_PAGE_INFO = 'RESET_TABLE_PAGE_INFO';

export const SET_TABLE_LOADING = 'SET_TABLE_LOADING';
